import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { Paper } from "../../../../../common/components/libs";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import { useTranslation } from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
          props => {
            return props.theme.spacing(6)
          }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoCategories = () => {

    const { menuStore } = useStores();
    const { forms } = menuStore;
    const hasIIkoIntegration = menuStore.hasIIkoIntegration();
    const { t } = useTranslation(["general", "menu"]);


    return <div style={{ maxWidth: 500 }}>
        <Wrapper>

            <Typography component="h1" variant="h4" align="center" gutterBottom>
                {t("menu:menuEditor.startCreatingMenu")} <span role="img" aria-label='newCategory'>😃</span>
            </Typography>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                {t("menu:menuEditor.descriptionMenu")}
            </Typography>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                <Button variant="contained"
                        color="primary"
                        onClick={() => forms.showPopupForm(MenuFormType.createMenuCategory)}
                >
                    <AddIcon/>
                    {t("menu:menuEditor.addCategory")}
                </Button>
            </div>


            {/*{
                hasIIkoIntegration && <>
                    <Typography component="h1" variant="h4" align="center" gutterBottom>
                        {t("menu:menuEditor.categoriesWillImportedFromIIko")}
                    </Typography>
                    <Typography component="h4" variant="body2" align="center" gutterBottom>
                        {t("menu:menuEditor.customizeExternalMenu")}
                    </Typography>
                </>
            }*/}

        </Wrapper>
    </div>
};


export default NoCategories
